module.exports = __webpack_public_path__ + "static/media/pollmaster-homescreen.2e96d5ad.png";